export default {
  path: '/login',
  name: 'Login',
  component: () => import('../views/layouts/Blank.layout.vue'),
  meta: {
    requiresAuth: false
  },
  children: [
    {
      path: '/',
      name: 'LoginProd',
      component: () => import('../views/pages/Login/Login.page.vue'),
      meta: {
        requiresAuth: false
      }
    },
    {
      path: 'uat',
      name: 'LoginUat',
      component: () => import('../views/pages/Login/LoginUat.page.vue'),
      meta: {
        requiresAuth: false
      }
    },
    {
      path: 'demo',
      name: 'LoginDemo',
      component: () => import('../views/pages/Login/LoginDemo.page.vue'),
      meta: {
        requiresAuth: false
      }
    }
  ]
}
